import React from 'react'
import { TextField } from '@material-ui/core';

const Profile = ({ config, draft, setDraft }) => {
  const onChange = (key, value) => setDraft({ ...draft, [key]: value });
  return (
    <>
      <TextField
        defaultValue={config?.appName}
        style={{
          marginBottom: 16
        }}
        fullWidth
        value={draft?.appName}
        label='Nama Aplikasi'
        InputLabelProps={{
          shrink: true
        }}
        onChange={(e) => onChange('appName', e.target.value)}
      />
      <TextField
        defaultValue={config?.hospitalName}
        style={{
          marginBottom: 16
        }}
        fullWidth
        label='Nama Perusahaan'
        value={draft?.hospitalName}
        onChange={(e) => onChange('hospitalName', e.target.value)}
        InputLabelProps={{
          shrink: true
        }}
      />
      <TextField
        defaultValue={config?.hospitalAddress}
        style={{
          marginBottom: 16
        }}
        fullWidth
        label='Alamat'
        value={draft?.hospitalAddress}
        onChange={(e) => onChange('hospitalAddress', e.target.value)}
        InputLabelProps={{
          shrink: true
        }}
      />
    </>
  )
}

export default Profile
